import { app } from '../../app.module'
app
  // ブランド名入力フォーム
  .directive('editBrandInfo', () => {
    return {
      restrict: 'E',
      template: require('./edit-brand-info.pug')(),
      controller: ($scope, UserService) => {
        // グループ一覧を取得
        UserService.Group.getGroupLists().then((groupLists) => {
          $scope.groups = groupLists
        })

        // 公開のグループ
        $scope.privateBrand = []

        /**
         * changePrivateBrandGroup 公開するグループを変更
         */
        $scope.changePrivateBrandGroup = function (privateBrand: {}[]) {
          $scope.brandData.groupIds = privateBrand
        }

        /**
         * editBrandInfo ブランド編集フォームを開く
         */
        $scope.editBrandInfo = function () {
          $scope.isInput = true

          // 公開のグループをセット
          $scope.privateBrand = $scope.brandData.groupIds
        }

        // メインカテゴリをセット
        $scope.category = $scope.brandData.category

        // カテゴリが変更された場合の処理
        $scope.$on('changeBrandCategory', (event, categoryInfo) => {
          if (categoryInfo.type !== 'edit-category') {
            return
          }
          // 選択したメインカテゴリ、サブカテゴリをセット
          $scope.categoryName = $scope.brandData.category
          $scope.subCategoryName = $scope.brandData.subCategory

          // メインカテゴリがある場合、スコープへカテゴリ、サブカテゴリを格納
          if (categoryInfo !== null) {
            $scope.categoryName = categoryInfo.categoryName
            $scope.subCategoryName =
              categoryInfo.subCategoryName !== '指定しない' ? categoryInfo.subCategoryName : null
          }
        })
      },
    }
  })
